/**
 * RESPONSIBILITY: one question an event is asked often, with its answer.
 */
import { Row, Text, Paragraph, RenderOf } from '@framework/core/decorators';

@Row()
export class FaqRow {
  @Text({ label: 'Question', maxLength: 300 })
  question!: string;

  @Paragraph({ label: 'Answer', maxLength: 4000, rows: 3, markdown: true })
  answer!: string;

  @RenderOf('answer')
  answerHtml!: string;
}
